import { render, staticRenderFns } from "./CategoryItemList.vue?vue&type=template&id=6a2066fa&scoped=true&"
import script from "./CategoryItemList.vue?vue&type=script&lang=ts&"
export * from "./CategoryItemList.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryItemList.vue?vue&type=style&index=0&id=6a2066fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2066fa",
  null
  
)

export default component.exports